export * from './Image';
export * from './Text';
//# sourceMappingURL=index.js.map